import Checkbox from "../../../../atoms/Checkbox";
import { usePrintComponentStore } from "../../store/usePrintComponentStore";

const PrintDisplayOptions: React.FC = () => {
  const { hasMoreExercises, hasAnswerSheet, setHasAnswerSheet, setHasMoreExercises, setNumberOfColumn, numberOfColumns } = usePrintComponentStore();

  return (
    <div className='flex justify-between gap-xl rounded-md bg-color-lighter p-4 xs:flex-col md:flex-row'>
      <Checkbox
        onChange={() => setHasMoreExercises(!hasMoreExercises)}
        label='Imprimir mais exercícios por página'
        checked={hasMoreExercises}
        id='more-exercises'
        value='more-exercises'
        variant='rounded'
      />
      <Checkbox
        onChange={() => setNumberOfColumn(numberOfColumns === 'split' ? 'single' : 'split')}
        label='Imprimir em uma coluna'
        checked={numberOfColumns === 'single'}
        id='column-number'
        value='column-number'
        variant='rounded'
      />
      <Checkbox
        onChange={() => setHasAnswerSheet(!hasAnswerSheet)}
        label='Adicionar gabarito no final da lista'
        checked={hasAnswerSheet}
        id='answer-key'
        value='answer-key'
        variant='rounded'
      />
    </div>
  )
}

export default PrintDisplayOptions;